import { render, staticRenderFns } from "./LivenessCheckView.vue?vue&type=template&id=0109f930&scoped=true&"
import script from "./LivenessCheckView.vue?vue&type=script&lang=js&"
export * from "./LivenessCheckView.vue?vue&type=script&lang=js&"
import style0 from "./LivenessCheckView.vue?vue&type=style&index=0&id=0109f930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0109f930",
  null
  
)

export default component.exports